import styled from "styled-components"
import { Main, Papa,EndDiv,EndeText,EndText2, TextTitle, UpDiv, Icons, IconImg, Icons2} from "../shared/StylePage"
import vk from '../img/Footer/vk.png'
import telegram from '../img/Footer/telegram.png'
import mail from '../img/Footer/mail.png'
import tel from '../img/Footer/tel.png'
import icn1 from '../img/Footer/oneG.png'
import icn2 from '../img/Footer/TwoG.png'
import icn3 from '../img/Footer/ThreeG.png'
import iconsquare from '../img/Footer/square.png'
import iconrhomb from '../img/Footer/rhomb.png'
import iconsun from '../img/Footer/sugnsign.png'





const Link = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
`
const Forma = styled.div`
    display: flex;
    gap: 25px;
`

const Img = styled.img`
    width: 25px;
`
const FormaLink = styled.a`
    text-decoration: none;
    color: #FFFFFF;
    font-size: 24px;
    margin: 0 0;
`

const Text = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`




export const Footer = () =>{
    const links = [
        {
            img: vk,
            text: 'https://vk.com/udmddn',
            textlink:'https://vk.com/udmddn'
        },
        {
            img: telegram,
            text: 'https://t.me/udmddn',
            textlink:'https://t.me/udmddn'
        },
        {
            img: mail,
            text: '+7 (3412) 63-10-11',
            textlink:'tell:+73412631011'
        },
        {
            img: tel,
            text: 'mail@ddn.udmr.ru',
            textlink:'mailto:mail@ddn.udmr.ru'
        },

    ]
    return(
        <Papa color="#272727">
        <Main color="#272727" padtop='29' padbott='60' id="s5" wrap='wrap'>
            <UpDiv>
                <Link>
                {
                    links.map((e) =>{
                        return(
                            <Forma>
                                <a href={e.textlink}><Img src={e.img} alt="" /></a>
                                <FormaLink href={e.textlink}>{e.text}</FormaLink>
                            </Forma>
                        )
                    })
                }
                </Link>
                <Icons>
                    <IconImg src={icn1} width='120' height='110'/>
                    <IconImg src={icn2} width='99' height='110'/>
                    <IconImg src={icn3} width='130' height='110'/>
                </Icons>
            </UpDiv>
            <Text>
                <TextTitle>«Удмуртия - вместе!»</TextTitle>
                <Icons2>
                    <IconImg src={iconsquare} width='19' height='19'/>
                    <IconImg src={iconsun} width='57' height='57'/>
                    <IconImg src={iconrhomb} width='45' height='45'/>
                </Icons2>
            </Text>
            <EndDiv padtop='40'>
                <EndeText>Форум местных сообществ</EndeText>
                <EndText2>7-30 апреля</EndText2>
            </EndDiv>
        </Main>
        </Papa>
    )
}